















import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { FETCH_CONTACT_LIST, GET_DOCTOR_LIST } from '../store';
import { Contact } from '../types';
import { ApiResponse } from '@/components/types';

const Contact = namespace('contact');

@Component({})
export default class DoctorCombobox extends Vue {
  @Prop({ type: String }) value!: string;
  @Prop({ type: Boolean, default: true }) required!: boolean;

  @Contact.Getter(GET_DOCTOR_LIST) list!: Contact[];
  @Contact.Action(FETCH_CONTACT_LIST) fetch!: () => Promise<ApiResponse>;

  get contact() {
    return this.value;
  }

  set contact(value: any) {
    if (typeof value === 'object') {
      this.$emit('select', value);
      return;
    }

    this.$emit('input', value);
  }

  get items() {
    return this.list
      .sort((first, second) => first.name.localeCompare(second.name));
  }

  created() {
    return this.fetch();
  }
}
